import { render, staticRenderFns } from "./create-tenant-page.vue?vue&type=template&id=f514e210&"
import script from "./create-tenant-page.vue?vue&type=script&lang=js&"
export * from "./create-tenant-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports